/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2017, 2019. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
/*global module*/
"use strict";

// 1x1 transparent PNG image
// TODO figure out a way to keep this as a SVG and have babel/webpack
// transform into a data URI that code can just `require()`
module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiBmaWxsPSIjRUU0RjNFIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgZmlsbC1ydWxlPSJldmVub2RkIj4KICA8cGF0aCBkPSJNMTIsMCBDNS40LDAgMCw1LjQgMCwxMiBDMCwxOC42IDUuNCwyNCAxMiwyNCBDMTguNiwyNCAyNCwxOC42IDI0LDEyIEMyNCw1LjQgMTguNiwwIDEyLDAgTDEyLDAgWiBNMTIsMjIgQzEwLjIsMjIgOC41LDIxLjUgNywyMC42IEw3LjEsMjAuNSBMMTkuMSw1LjUgTDE5LjMsNS4xIEMyMSw3IDIyLDkuNCAyMiwxMiBDMjIsMTcuNSAxNy41LDIyIDEyLDIyIEwxMiwyMiBaIE0xMiwyIEMxMy44LDIgMTUuNSwyLjUgMTcsMy40IEwxNywzLjUgTDUsMTguNSBMNC44LDE4LjkgQzMsMTcgMiwxNC42IDIsMTIgQzIsNi41IDYuNSwyIDEyLDIgTDEyLDIgWiI+PC9wYXRoPgo8L3N2Zz4=";